module.exports = __webpack_public_path__ + "img/sticky-top.7cc1df4.png";